import { IconPropsType } from '..';

export const VatanOriginalsIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.42214 2.84409L6.37218 4.96078L8.39432 4.38786L5.58472 13.255L6.11456 7.45862L4.37192 8.14421L3.6841 2.5013L0.330078 0.899994L6.03921 17.1L11.7459 0.899994L7.42214 2.84409Z" />
  </svg>
);
